import { useState, useEffect } from 'react';
import { getAuth, signInWithPopup, signInWithEmailAndPassword, GoogleAuthProvider, onAuthStateChanged, getIdToken, sendEmailVerification, createUserWithEmailAndPassword } from "firebase/auth";
import initializeAuth from "./firebase.init";

initializeAuth();

const useCaseFirebase = () => {
    const [user, setUser] = useState({});
    const auth = getAuth();
    const [reload, setReload] = useState(false);
    const googleProvider = new GoogleAuthProvider();

    const signInUsingGoogle = (navigate, location) => {
        signInWithPopup(auth, googleProvider)
            .then(res => {
                setUser(res.user);
                const redirect = location?.state?.from || "/";
                navigate(redirect);
            })
            .catch((error) => {
                const errorMessage = error.message;
                console.log(errorMessage);
            })
    }

    const createNewUserUsingEmailPassword = (
        email,
        password,
        displayName,
        navigate,
    ) => {
        createUserWithEmailAndPassword(auth, email, password)
            .then((res) => {
                sendEmailVerification(auth.currentUser);
                const newUser = { ...res.user };
                newUser.displayName = displayName;
                setUser(newUser);
                navigate(`/check-email/${res.user.email}`);
            })
            .catch((error) => {
                const errorMessage = error.message;
                console.log('Error message', errorMessage)
            })
    };


    const signInWithEmailPassword = (
        email,
        password,
        navigate,
        location,
        setLoader
    ) => {

        signInWithEmailAndPassword(auth, email, password)
            .then((res) => {
                const newUser = { ...user };
                newUser.email = email;
                newUser.password = password;
                setReload(true);
                const redirect = location?.state?.from || "/";
                navigate(redirect);
            })

            .catch((error) => {
                setLoader(false)
                alert('Sorry! Your password or email does not match.')
            })
    };
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user?.emailVerified) {
                getIdToken(user)
                    .then(idToken => localStorage.setItem('cashew-token', idToken));
                setUser(user);
            }
            else {
                setUser({});
            }
        });
        setReload(false);
        return () => unsubscribe;
    }, [reload, auth])

    return {
        user,
        signInUsingGoogle,
        createNewUserUsingEmailPassword,
        signInWithEmailPassword
    }
}


export default useCaseFirebase;